import { render, staticRenderFns } from "./barChartThree.vue?vue&type=template&id=1a85f636"
import script from "./barChartThree.vue?vue&type=script&lang=js"
export * from "./barChartThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports